import LBox from "@components/LBox";
import LPressable from "@components/LPressable";
import LText from "@components/LText";
import { fonts } from "@theme";
import { memo } from "react";

interface HeaderSWMProps {
  pressable?: {
    onPress: () => void;
    sentryEventName: string;
  };
  rightPressable?: {
    onPress: () => void;
    sentryEventName: string;
  };
  rightText?: string | null;
  text: string;
}

const HeaderSWMComponent = ({
  pressable,
  rightPressable,
  rightText,
  text,
}: HeaderSWMProps) => (
  <LBox
    alignItems="center"
    flexDirection="row"
    justifyContent="space-between"
    marginBottom="s3"
  >
    <LPressable
      disabled={pressable === undefined}
      onPress={pressable?.onPress}
      sentryEventName={pressable?.sentryEventName ?? ""}
    >
      <LText
        color="blackTranslucent70"
        fontFamily={fonts.bold}
        lineHeight={22}
        variant="bodyM2"
      >
        {text}
      </LText>
    </LPressable>
    {rightText ? (
      <LPressable
        disabled={rightPressable === undefined}
        onPress={rightPressable?.onPress}
        sentryEventName={rightPressable?.sentryEventName ?? ""}
      >
        <LText
          color="blackTranslucent70"
          fontFamily={fonts.regular}
          lineHeight={22}
          numberOfLines={1}
          variant="bodyM2"
        >
          {rightText}
        </LText>
      </LPressable>
    ) : null}
  </LBox>
);

export const HeaderSWM = memo(HeaderSWMComponent);
